import React, { useRef, useEffect } from 'react';

const DialougeTreeInfoGraphics = ({
    title,
    problemCode,
    category,
    subCategory,
    concern,
    problemStatement,
    why1,
    why2,
    why3,
    why4,
    why5,
    rootCause,
    fontSize,
    lineHeight,
    maxWidth,

    startXTitle,
    startYTitle,
    startXProblemCode,
    startYProblemCode,
    startXCategory,
    startYCategory,
    startXSubCategory,
    startYSubCategory,

    startXConcern,
    startYConcern,
    startXProblemStatement,
    startYProblemStatement,
    startXWhy1,
    startYWhy1,
    startXWhy2,
    startYWhy2,
    startXWhy3,
    startYWhy3,
    startXWhy4,
    startYWhy4,
    startXWhy5,
    startYWhy5,
    startXRootCause,
    startYRootCause,

    why11,
    why21,
    why31,
    why41,
    why51,
    rootCause1,
    startXWhy11, 
    startYWhy11, 
    startXWhy21, 
    startYWhy21, 
    startXWhy31, 
    startYWhy31, 
    startXWhy41, 
    startYWhy41,
    startXWhy51,
    startYWhy51, 
    startXRootCause1, 
    startYRootCause1,

    why12,
    why22,
    why32,
    why42,
    why52,
    rootCause2,
    startXWhy12, 
    startYWhy12, 
    startXWhy22, 
    startYWhy22, 
    startXWhy32, 
    startYWhy32, 
    startXWhy42, 
    startYWhy42,
    startXWhy52,
    startYWhy52, 
    startXRootCause2, 
    startYRootCause2,

    why13,
    why23,
    why33,
    why43,
    why53,
    rootCause3,
    startXWhy13, 
    startYWhy13, 
    startXWhy23, 
    startYWhy23, 
    startXWhy33, 
    startYWhy33, 
    startXWhy43, 
    startYWhy43,
    startXWhy53,
    startYWhy53, 
    startXRootCause3, 
    startYRootCause3,

    why14,
    why24,
    why34,
    why44,
    why54,
    rootCause4,
    startXWhy14, 
    startYWhy14, 
    startXWhy24, 
    startYWhy24, 
    startXWhy34, 
    startYWhy34, 
    startXWhy44,
    startYWhy44,
    startXWhy54,
    startYWhy54, 
    startXRootCause4, 
    startYRootCause4,

    why15,
    why25,
    why35,
    why45,
    why55,
    rootCause5,
    startXWhy15, 
    startYWhy15, 
    startXWhy25, 
    startYWhy25, 
    startXWhy35, 
    startYWhy35, 
    startXWhy45, 
    startYWhy45,
    startXWhy55,
    startYWhy55, 
    startXRootCause5, 
    startYRootCause5,

    imageSrc,
    viewWidth,
}) => {
    const canvasRef = useRef(null);

    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        // console.log(text);
        var words = text.split(' ');
        var line = '';
        for (var i = 0; i < words.length; i++) {
            var testLine = line + words[i] + ' ';
            var metrics = ctx.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > maxWidth && i > 0) {
                ctx.fillText(line, x, y);
                line = words[i] + ' ';
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        maxWidth = viewWidth; //viewWidth;

        // Draw the image
        const image = new Image();
        image.onload = function () {
            canvas.width = image.width;
            canvas.height = image.height;

            ctx.drawImage(image, 0, 0);

            // Draw the elements
            ctx.font = `${fontSize}px Arial`;
            wrapText(ctx, problemCode, startXProblemCode, startYProblemCode, maxWidth, lineHeight);
            wrapText(ctx, problemStatement, startXProblemStatement, startYProblemStatement, 700, lineHeight);
            
            wrapText(ctx, why11, startXWhy11, startYWhy11, 100, lineHeight);
            wrapText(ctx, why21, startXWhy21, startYWhy21, 100, lineHeight);
            wrapText(ctx, why31, startXWhy31, startYWhy31, 100, lineHeight);
            wrapText(ctx, why41, startXWhy41, startYWhy41, 100, lineHeight);
            wrapText(ctx, why51, startXWhy51, startYWhy51, 100, lineHeight);
            wrapText(ctx, rootCause1, startXRootCause1, startYRootCause1, 100, lineHeight);

            wrapText(ctx, why12, startXWhy12, startYWhy12, 100, lineHeight);
            wrapText(ctx, why22, startXWhy22, startYWhy22, 100, lineHeight);
            wrapText(ctx, why32, startXWhy32, startYWhy32, 100, lineHeight);
            wrapText(ctx, why42, startXWhy42, startYWhy42, 100, lineHeight);
            wrapText(ctx, why52, startXWhy52, startYWhy52, 100, lineHeight);
            wrapText(ctx, rootCause2, startXRootCause2, startYRootCause2, 100, lineHeight);

            wrapText(ctx, why13, startXWhy13, startYWhy13, 100, lineHeight);
            wrapText(ctx, why23, startXWhy23, startYWhy23, 100, lineHeight);
            wrapText(ctx, why33, startXWhy33, startYWhy33, 100, lineHeight);
            wrapText(ctx, why43, startXWhy43, startYWhy43, 100, lineHeight);
            wrapText(ctx, why53, startXWhy53, startYWhy53, 100, lineHeight);
            wrapText(ctx, rootCause3, startXRootCause3, startYRootCause3, 100, lineHeight);

            wrapText(ctx, why14, startXWhy14, startYWhy14, 100, lineHeight);
            wrapText(ctx, why24, startXWhy24, startYWhy24, 100, lineHeight);
            wrapText(ctx, why34, startXWhy34, startYWhy34, 100, lineHeight);
            wrapText(ctx, why44, startXWhy44, startYWhy44, 100, lineHeight);
            wrapText(ctx, why54, startXWhy54, startYWhy54, 100, lineHeight);
            wrapText(ctx, rootCause4, startXRootCause4, startYRootCause4, 100, lineHeight);

            wrapText(ctx, why15, startXWhy15, startYWhy15, 100, lineHeight);
            wrapText(ctx, why25, startXWhy25, startYWhy25, 100, lineHeight);
            wrapText(ctx, why35, startXWhy35, startYWhy35, 100, lineHeight);
            wrapText(ctx, why45, startXWhy45, startYWhy45, 100, lineHeight);
            wrapText(ctx, why55, startXWhy55, startYWhy55, 100, lineHeight);
            wrapText(ctx, rootCause5, startXRootCause5, startYRootCause5, 100, lineHeight);

            wrapText(ctx, rootCause, startXRootCause, startYRootCause, 700, lineHeight);
            wrapText(ctx, why1, startXWhy1, startYWhy1, 100, lineHeight);
            wrapText(ctx, why2, startXWhy2, startYWhy2, 100, lineHeight);
            wrapText(ctx, why3, startXWhy3, startYWhy3, 100, lineHeight);
            wrapText(ctx, why4, startXWhy4, startYWhy4, 100, lineHeight);
            wrapText(ctx, why5, startXWhy5, startYWhy5, 100, lineHeight);
        };
        image.src = imageSrc;
    }, [
        title,
        problemCode,
        category,
        subCategory,
        concern,
        problemStatement,
        why1,
        why2,
        why3,
        why4,
        why5,
        rootCause,
        fontSize,
        lineHeight,
        maxWidth,

        startXTitle,
        startYTitle,
        startXProblemCode,
        startYProblemCode,
        startXCategory,
        startYCategory,
        startXSubCategory,
        startYSubCategory,

        startXConcern,
        startYConcern,
        startXProblemStatement,
        startYProblemStatement,
        startXWhy1,
        startYWhy1,
        startXWhy2,
        startYWhy2,
        startXWhy3,
        startYWhy3,
        startXWhy4,
        startYWhy4,
        startXWhy5,
        startYWhy5,
        startXRootCause,
        startYRootCause,

        why11,
        why21,
        why31,
        why41,
        why51,
        rootCause1,
        startXWhy11, 
        startYWhy11, 
        startXWhy21, 
        startYWhy21, 
        startXWhy31, 
        startYWhy31, 
        startXWhy41, 
        startYWhy41,
        startXWhy51,
        startYWhy51, 
        startXRootCause1, 
        startYRootCause1,

        why12,
        why22,
        why32,
        why42,
        why52,
        rootCause2,
        startXWhy12, 
        startYWhy12, 
        startXWhy22, 
        startYWhy22, 
        startXWhy32, 
        startYWhy32, 
        startXWhy42, 
        startYWhy42,
        startXWhy52,
        startYWhy52, 
        startXRootCause2, 
        startYRootCause2,

        why13,
        why23,
        why33,
        why43,
        why53,
        rootCause3,
        startXWhy13, 
        startYWhy13, 
        startXWhy23, 
        startYWhy23, 
        startXWhy33, 
        startYWhy33, 
        startXWhy43, 
        startYWhy43,
        startXWhy53,
        startYWhy53, 
        startXRootCause3, 
        startYRootCause3,

        why14,
        why24,
        why34,
        why44,
        why54,
        rootCause4,
        startXWhy14, 
        startYWhy14, 
        startXWhy24, 
        startYWhy24, 
        startXWhy34, 
        startYWhy34, 
        startXWhy44,
        startYWhy44,
        startXWhy54,
        startYWhy54, 
        startXRootCause4, 
        startYRootCause4,

        why15,
        why25,
        why35,
        why45,
        why55,
        rootCause5,
        startXWhy15, 
        startYWhy15, 
        startXWhy25, 
        startYWhy25, 
        startXWhy35, 
        startYWhy35, 
        startXWhy45, 
        startYWhy45,
        startXWhy55,
        startYWhy55, 
        startXRootCause5, 
        startYRootCause5,
        
        imageSrc,
        viewWidth,
    ]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                maxWidth: '100%',
            }}
        ></canvas>
    );
};

export default DialougeTreeInfoGraphics;
